import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Martina K.",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&q=80",
    achievement: "Stratila 12 kg za 6 mesiacov",
    rating: 5,
    text: "Začala som trénovať s Danou pred 6 mesiacmi a nielen som stratila 12 kg, ale cítim sa omnoho silnejšia a sebavedomejšia. Tréningy sú náročné, ale Danka vždy vie ako ťa motivovať a neustále posúvať vpred.",
  },
  {
    name: "Peter H.",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&q=80",
    achievement: "Nabral 8 kg svalovej hmoty",
    rating: 5,
    text: "Ako muž som sa sprvu obával, ale Danka je absolútna profesionálka. Za 3 mesiace som nadobudol viditeľnú svalovú hmotu a moja sila sa takmer zdvojnásobila. Skvelá kombinácia tréningov a výživového plánu!",
  },
  {
    name: "Jana M.",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&q=80",
    achievement: "Zbavila sa chronickej bolesti chrbta",
    rating: 5,
    text: "Výživový plán, ktorý mi Danka zostavila, zmenil môj život. Cítim sa plná energie celý deň. A vďaka silovému tréningu sa mi úplne vytratila chronická bolesť chrbta, s ktorou som trpela roky.",
  },
  {
    name: "Lucia S.",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&q=80",
    achievement: "Prebehla prvý polmaratón",
    rating: 5,
    text: "Danka je viac než len trénerka – je to mentor a motivátor. Po roku spolupráce som si splnila môj fitness sen a prebehla prvý polmaratón. Bez Dany by to bolo nemysliteľné. Vrelo odporúčam každému!",
  },
];

export default function Reviews() {
  return (
    <section
      id="recenzie"
      className="py-24 lg:py-32 relative overflow-hidden"
      style={{ background: "#252540" }}
    >
      {/* Top gradient */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1C1C2E] to-transparent pointer-events-none" />

      {/* Decorative blob */}
      <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-[#F72585]/8 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#F72585] block mb-3">
            Hovoria naši klienti
          </span>
          <h2
            className="text-4xl lg:text-5xl font-black uppercase tracking-tight text-white"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            RECENZIE
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reviews.map((review, i) => (
            <motion.div
              key={review.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.6 }}
              data-testid={`review-card-${i}`}
              className="rounded-2xl p-6 lg:p-8 relative overflow-hidden"
              style={{
                background: "#2A2A44",
                border: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              {/* Decorative large quote */}
              <div
                className="absolute top-2 right-4 text-[7rem] leading-none font-black select-none pointer-events-none"
                style={{
                  fontFamily: "Outfit, sans-serif",
                  color: "rgba(114,9,183,0.12)",
                }}
              >
                "
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, j) => (
                  <Star key={j} size={15} fill="#F72585" stroke="none" />
                ))}
              </div>

              {/* Review text */}
              <p
                className="text-zinc-300 leading-relaxed mb-5 relative z-10 text-sm lg:text-base"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                "{review.text}"
              </p>

              {/* Achievement badge */}
              <div
                className="inline-block text-xs font-bold px-3 py-1.5 rounded-full mb-5"
                style={{
                  background: "rgba(247,37,133,0.1)",
                  color: "#F72585",
                }}
              >
                {review.achievement}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                  style={{ border: "2px solid rgba(247,37,133,0.3)" }}
                />
                <span className="font-semibold text-white text-sm">
                  {review.name}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#252540] to-transparent pointer-events-none" />
    </section>
  );
}
